import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImageAltText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImageAltText"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM4.5 4.5V10.2141L7.95046 6.67518L14.5933 13.5H19.5V4.5H4.5ZM19.5 15H4.5V19.5H19.5V15ZM13.5 8.25C13.5 7.00736 14.5074 6 15.75 6C16.9926 6 18 7.00736 18 8.25C18 9.49264 16.9926 10.5 15.75 10.5C14.5074 10.5 13.5 9.49264 13.5 8.25ZM6 16.5H13V18H6V16.5ZM14.5 16.5H18V18H14.5V16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImageAltText;
